import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/content-slider/content-slider';
import 'Bem/site/list-author-blocks/list-author-blocks';
import 'Bem/site/triple-slider/triple-slider';
import 'Bem/site/main-slider2/main-slider2';
import 'Bem/site/info-slider/info-slider';
import 'Bem/site/form-custom/form-custom';
import 'Bem/site/offer-list/offer-list';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import { Popup } from 'Lib/popup/popup';
import { oLike } from 'Lib/like/like';

oLike.init('.js-book-like');

const popup1 = new Popup('popup', document.querySelector('.author__head-popup1'));
const popup2 = new Popup('popup', document.querySelector('.author__head-popup2'));

document.querySelector('.author__head-btn_order-call1')?.addEventListener('click', () => {
    popup1.open();
});

document.querySelector('.author__head-btn_order-call2')?.addEventListener('click', () => {
    popup2.open();
});

svgSpriteLoader('/landing/author/svg/sprite.svg?v=20180920');